import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router'

import { AuthService } from '../services/auth.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class IsNotAuthenticatedGuard {
  constructor(private router: Router, private authService: AuthService) {}

  async canActivate(_next: ActivatedRouteSnapshot, _snapshot: RouterStateSnapshot) {
    try {
      const user = await this.authService.getUser()
      if (!user) {
        return true
      } else {
        this.router.navigate(['/'])
        return false
      }
    } catch (_error) {
      // If auth service fails, assume user is not authenticated and allow access
      return true
    }
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(childRoute, state)
  }
}
